import { createReducer, on } from '@ngrx/store';
import { User } from '../user.model';
import * as AuthActions from './auth.actions';

export interface State {
  user: User | null;
  authError: string | null;
  loading: boolean;
  autoLoginAttempted: boolean;
}

const initialState: State = {
  user: null,
  authError: null,
  loading: false,
  autoLoginAttempted: false,
};

export const authReducer = createReducer(
  initialState,

  on(AuthActions.authentificateSuccess, (state, { username, userId, token, expirationDate, isStaff, isSuperuser, groups }) => ({
    ...state,
    authError: null,
    user: new User(username, userId, token, expirationDate, isStaff, isSuperuser, groups),
    loading: false,
    autoLoginAttempted: true,
  })),

  on(AuthActions.autoLoginFinished, (state) => ({
    ...state,
    autoLoginAttempted: true,
  })),

  on(AuthActions.logout, (state) => ({
    ...state,
    user: null,
  })),

  on(AuthActions.loginStart, (state) => ({
    ...state,
    authError: null,
    loading: true,
  })),

  on(AuthActions.authentificateFail, (state, { payload }) => ({
    ...state,
    user: null,
    authError: payload,
    loading: false,
  })),

  on(AuthActions.clearError, (state) => ({
    ...state,
    authError: null,
  })),

  on(AuthActions.updateGroups, (state, { groups }) => {
    if (!state.user) return state;
    const updatedUser = new User(
      state.user.username,
      state.user.id,
      (state.user as any)._token,
      (state.user as any)._tokenExpirationDate,
      state.user.isStaff,
      state.user.isSuperuser,
      groups
    );
    // Also update localStorage
    localStorage.setItem('userData', JSON.stringify(updatedUser));
    return {
      ...state,
      user: updatedUser
    };
  })
);
